module.exports = __webpack_public_path__ + "assets/Angle45.48ae8afa9e0bc552aadf7adb7b7211cf.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle45.gmt
// module id = 894
// module chunks = 0